import { func, arrayOf, string } from 'prop-types';
import { getInvalidItem, scrollToItem } from 'components/Forms/utilities/ErrorScrolling/util';

const ErrorScrolling = props => component => {
  const { submitResult, errorOrder } = props;

  return component({
    ...props,
    onSubmitErrorScroll: async (data, event) => {
      if (event && event.preventDefault) {
        event.preventDefault();
      }

      const items = await submitResult(data);
      const invalidItem = await getInvalidItem(items, errorOrder);
      return invalidItem && scrollToItem(invalidItem);
    },
  });
};

ErrorScrolling.propTypes = {
  submitResult: func.isRequired,
  errorOrder: arrayOf(string).isRequired,
};

export default ErrorScrolling;
